// extracted by mini-css-extract-plugin
export default {"sidebar":"AdminSideBar_sidebar__uPEyr","active":"AdminSideBar_active__aEoZa","logoutButton":"AdminSideBar_logoutButton__NIfRj"};